import styled from "styled-components";
import { Column, Flex } from "./Utils";

export const MainContainer = styled(Column)<{
  $padding?: string;
  $zIndex?: number;
}>`
  border-radius: 30px;
  width: 100%;
  padding: ${(props) => props.$padding ?? "2rem 1rem"};
  border: ${(props) => `2px solid ${props.theme.color.primaryDark}`};
  background-color: ${(props) => props.theme.color.primaryLight};
  height: 100%;
  align-items: center;
  z-index: ${(props) =>
    props.$zIndex ?? 0}; // Allow to display Images bellow container content. TODO : replace this quick trick.
`;

// export const RootContainer = styled.div<{
export const RootContainer = styled(Flex)<{
  $background?: string;
  $height?: string;
  $topSafe?: boolean;
}>`
  position: relative;
  background-color: ${(props) => props.$background};
  min-height: inherit;
  height: ${(props) => props.$height ?? "unset"};
  padding-top: ${(props) =>
    props.$topSafe
      ? `calc(${props.theme.rootContainerBlockPadding} + env(safe-area-inset-top))`
      : props.theme.rootContainerBlockPadding};
  padding-inline: ${(props) => props.theme.rootContainerInlinePadding};
  padding-bottom: ${(props) => props.theme.rootContainerBlockPadding};
  display: flex;
  flex-direction: column;
`;

// export const DogNameCurvedContainer = styled.div<{ $viewportWidth: number }>`
//   /* transform: translateY(30%); */
//   height: ${(props) => (props.$viewportWidth * 19) / 100 + "px"};
//   z-index: 99;
//   width: 100%;
// `;

export const QuestionContainer = styled(Column)`
  align-items: flex-start;
  padding: 2rem;
  border-radius: 30px;
  background-color: ${(props) => props.theme.color.primaryChill};
  width: 100%;
`;
